"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCourseStatus = exports.UserReportCard = void 0;
var typeorm_1 = require("typeorm");
var Users_js_1 = require("./Users.js");
var UserCourseStatus;
(function (UserCourseStatus) {
  UserCourseStatus["SIGNEDUP"] = "SIGNEDUP";
  UserCourseStatus["APTTESTLINKGENERATED"] = "APTTESTLINKGENERATED";
  UserCourseStatus["APTTESTPASSED"] = "APTTESTPASSED";
  UserCourseStatus["PRECOURSEENROLLED"] = "PRECOURSEENROLLED";
  UserCourseStatus["PRECOURSECOMPLETED"] = "PRECOURSECOMPLETED";
  UserCourseStatus["INTERVIEW"] = "INTERVIEW";
  UserCourseStatus["FULLCOURSESTARTED"] = "FULLCOURSESTARTED";
})(UserCourseStatus || (UserCourseStatus = {}));
exports.UserCourseStatus = UserCourseStatus;
var UserReportCard = /** @class */function () {
  function UserReportCard() {}
  __decorate([(0, typeorm_1.PrimaryGeneratedColumn)("uuid"), __metadata("design:type", String)], UserReportCard.prototype, "id", void 0);
  __decorate([(0, typeorm_1.OneToOne)(function (type) {
    return Users_js_1.Users;
  }), (0, typeorm_1.JoinColumn)(), __metadata("design:type", String)], UserReportCard.prototype, "user", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], UserReportCard.prototype, "gradezyUserId", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: UserCourseStatus.SIGNEDUP
  }), __metadata("design:type", String)], UserReportCard.prototype, "userCourseStatus", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], UserReportCard.prototype, "aptitudeTestLink", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Date)], UserReportCard.prototype, "aptitudeTestLinkGenerationTime", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Date)], UserReportCard.prototype, "aptitudeTestSubmissionDate", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: false
  }), __metadata("design:type", Boolean)], UserReportCard.prototype, "aptitudeTestCleared", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], UserReportCard.prototype, "aptitudeTestReportId", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], UserReportCard.prototype, "codingTestLink", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Date)], UserReportCard.prototype, "codingTestLinkGenerationTime", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Date)], UserReportCard.prototype, "codingTestSubmissionDate", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Date)], UserReportCard.prototype, "codingTestSubmissionDate2", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: 0
  }), __metadata("design:type", Number)], UserReportCard.prototype, "codingTestSubmittedCount", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: false
  }), __metadata("design:type", Boolean)], UserReportCard.prototype, "codingTestCleared", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], UserReportCard.prototype, "codingTestReportId", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: false
  }), __metadata("design:type", Boolean)], UserReportCard.prototype, "interviewCleared", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Date)], UserReportCard.prototype, "interviewDate", void 0);
  __decorate([(0, typeorm_1.CreateDateColumn)(), __metadata("design:type", Date)], UserReportCard.prototype, "created_at", void 0);
  __decorate([(0, typeorm_1.UpdateDateColumn)(), __metadata("design:type", Date)], UserReportCard.prototype, "updated_at", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Date)], UserReportCard.prototype, "lastInterviewBookingDate", void 0);
  UserReportCard = __decorate([(0, typeorm_1.Entity)()], UserReportCard);
  return UserReportCard;
}();
exports.UserReportCard = UserReportCard;